'use strict'; // go env doesn't have and need XMLHttpRequest

if (typeof XMLHttpRequest === 'undefined') {
  exports.XMLHttpRequest = {};
} else {
  exports.XMLHttpRequest = XMLHttpRequest; // jshint ignore:line
}